import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersPrivateQuestionAnswersIndexRequestType,
  ApiManagersPrivateQuestionAnswersIndexResponseType,
} from "~/domains";

type RequestDataType = {
  params?: ApiManagersPrivateQuestionAnswersIndexRequestType;
  page?: number;
};

const request = async ({
  params,
  page = 1,
}: RequestDataType): Promise<ApiManagersPrivateQuestionAnswersIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiManagersPrivateQuestionAnswersIndexResponseType>(
      "/api/managers/private_question_answers",
      { page, ...params },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiManagersPrivateQuestionAnswersIndexRequestType;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisManagersPrivateQuestionAnswersIndex = ({
  params,
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ApiManagersPrivateQuestionAnswersIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisManagersPrivateQuestionAnswersIndex", params],
    ({ pageParam }) => {
      return request({ params, page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
